/** @type {Styles} */

export const styles = {
  accordion: {
    boxShadow: 0,
    backgroundColor: 'gray.0',
    borderRadius: 1,
    border: 1,
    borderColor: 'gray.8',
    '&:before': { visibility: 'hidden' },
  },
  accordionGhost: {
    border: 0,
    backgroundColor: 'transparent',
    width: '100%',
  },

  label: {
    typography: 'medium',
    fontWeight: 600,
    color: 'gray.80',
  },
  summaryWrapper: {
    backgroundColor: 'gray.3',
    borderRadius: 1,
    border: 1,
    margin: '-1px',
    borderColor: 'gray.8',
    '&:hover': {
      backgroundColor: 'gray.8',
    },
  },
  summaryWrapperGhost: {
    border: 0,
    backgroundColor: 'transparent',
    '&:hover': { backgroundColor: 'transparent' },
  },
  summaryWrapperButton: { '&:hover': { backgroundColor: 'gray.3' } },
  summary: {
    paddingX: 1.5,
    '.MuiAccordionSummary-content': {
      marginY: 0,
      justifyContent: 'space-between',
      alignItems: 'center',
      marginRight: { xs: 0, md: 2 },
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      '& .MuiIconButton-root': {
        width: 32,
        height: 32,
      },
    },
    '.MuiSvgIcon-root': {
      color: 'gray.64',
    },
  },
  expandLabelSummary: {
    '& .MuiAccordionSummary-expandIconWrapper': {
      marginRight: 13,
    },
  },
  expandLabelSummaryMobile: {
    '& .MuiAccordionSummary-expandIconWrapper': {
      marginRight: { xs: 0, md: 4.5 },
      marginLeft: { xs: 0, md: 0.5 },
    },
  },
  summaryGhost: {
    '.MuiAccordionSummary-content': { marginY: 2.5 },
    marginX: 1.5,
    paddingX: 0,
    borderBottom: 1,
    borderColor: 'transparent',
    '&.Mui-expanded, :hover': {
      borderColor: 'gray.8',
    },
  },
  detailsGhost: {
    backgroundColor: 'transparent',
  },
  expandIcon: {
    fontSize: 20,
  },
  lockIcon: {
    fontSize: 20,
    color: 'gray.40',
  },
  lockedLabel: {
    color: 'gray.40',
    cursor: 'not-allowed',
  },
  button: {
    color: 'gray.80',
    fontWeight: 600,
    '&:hover, &:focus': { color: 'gray.80', backgroundColor: 'gray.8' },
    '& .MuiButton-startIcon .MuiSvgIcon-root': {
      fontSize: 18,
    },
  },
  startContentSummary: {
    alignItems: 'center',
    color: 'gray.64',
    '.MuiSvgIcon-root': {
      fontSize: 6,
    },
  },
  columnStartContentSummary: {
    color: 'gray.64',
    '.MuiSvgIcon-root': {
      fontSize: 6,
    },
  },
  descriptionStack: {
    alignItems: 'center',
  },
  description: {
    typography: 'medium',
    width: 'max-content',
  },
  dividerStyle: {
    marginBottom: 1,
    zIndex: 1000,
  },
  borderTopSummary: {
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: (theme) => theme.palette.gray[12],
  },
  chip: {
    borderRadius: 1,
    typography: 'small',
    fontWeight: 600,

    '&.MuiChip-filledPrimary': {
      backgroundColor: 'primary.lightest',
      color: 'primary.main',
    },
    '.MuiChip-icon': { fontSize: 16, marginY: 'auto' },
  },
  expandLabelWrapper: {
    position: 'absolute',
    right: '4px',
    alignItems: 'center',
  },
  iconButton: {
    padding: { xs: 0, md: '8px' },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  viewOnly: {
    ':hover:not(.Mui-disabled)': {
      cursor: 'default',
    },
  },
}
